import { MissionBadge } from '@/features/missions/components/MissionBadge'
import type { ProficiencyAssessmentFinalResult } from '@/features/nectar/api/models'
import { Button, Text } from '@/ui-kit'
import { Gift } from 'lucide-react'

type PhaseClaimRewardProps = {
  finalResult: ProficiencyAssessmentFinalResult
  claiming: boolean
  onClaim: () => void
}

export const PhaseClaimReward = ({ finalResult, claiming, onClaim }: PhaseClaimRewardProps) => {
  return (
    <div
      className="mx-auto flex w-full max-w-[600px] flex-col items-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center"
      style={{ animation: 'nectar-slide-up 0.4s ease-out' }}
    >
      <div className="flex size-16 items-center justify-center rounded-full bg-green/10">
        <Gift className="text-green size-8" />
      </div>

      <Text type="h5">Assessment Already Completed</Text>

      <div className="flex flex-col items-center gap-2">
        <Text type="body2-regular" className="text-gray-80">
          You already completed a proficiency assessment with result:
        </Text>
        <span className="text-h3 block">{finalResult.level}</span>
        <MissionBadge variant="success">
          {finalResult.confidence === 'high'
            ? 'High confidence'
            : finalResult.confidence === 'medium'
              ? 'Medium confidence'
              : 'Low confidence'}
        </MissionBadge>
      </div>

      <Text type="body2-regular" className="text-gray-80">
        Claim your reward for this task.
      </Text>

      <Button onClick={onClaim} isDisabled={claiming} className="w-full max-w-[300px]">
        {claiming ? 'Claiming...' : 'Claim Reward'}
      </Button>
    </div>
  )
}
